import { HttpClient, HttpResponse } from "@angular/common/http";
import { Component, Input } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import jsPDF from "jspdf";

@Component({
  selector: "app-pdf-view-popup",
  templateUrl: "./pdf-view-popup.component.html",
  styleUrls: ["./pdf-view-popup.component.scss"],
})
export class PdfViewPopupComponent {
  @Input() document: jsPDF;
  isLoading: boolean = false;

  constructor(
    private popoverCtrl: PopoverController,
    private http: HttpClient
  ) {}

  ngOnInit() {}

  viewPDF() {
    this.isLoading = true;
    const data = { document: this.document };
    this.popoverCtrl.dismiss(true)
    this.isLoading = false


    // this.http
    //   .post("/print", data, { observe: "response" })
    //   .subscribe((res: HttpResponse<any>) => {
    //     this.popoverCtrl.dismiss(res?.body?.uuid);
    //     this.isLoading = false;
    //   });
  }

  onClose() {
    this.popoverCtrl.dismiss(null);
  }
}
